import './HeroSectionStyle.css';

export const HeroSection = () => (
  <section className="w-[90%] mx-auto sm:w-full text-white">
    <div className="max-w-7xl relative rounded-xl bg-img-Contact div-height sm:h-[40vh] mx-auto flex sm:px-[100px] z-0">
      
      {/* Background Image */}
      <img
        src="/assets/img/womenOnCallBW.png"
        className="absolute bg-img-position top-0 left-0 object-cover bg-green-900/80 h-full w-full rounded-xl z-0 mix-blend-multiply"
        alt="Background"
      />

      {/* ✅ Mobile View Text */}
      <div className="sm:hidden absolute inset-0 flex flex-col items-center justify-start pt-[20vh] text-center px-4 z-10">
        <h1 className="text-4xl xs:text-3xl font-bomstad-semibold text-left mb-2  leading-[1]">
          Let's Talk! We <br/> Don't Ghost!
        </h1>
        <p className="text-[17px] xs:text-[14px] leading-[1] w-[80%] text-green-100 text-left font-atkinson">
          Got a question? Or just in the mood for a chat? 
          We're all ears and keyboards! Hit us up—we make
          insurance talk less 'ugh' and more 'aha!'
        </p>
      </div>

      {/* ✅ Desktop View (Unchanged) */}
      <div className="hidden sm:flex w-full flex-col lg:flex-row items-center z-10">
        <div className="mb-8 lg:mb-0">
          <h1 className="text-3xl font-bomstad-semibold md:text-4xl mb-4">
            Let's Talk! We Don't Ghost!
          </h1>
          <p className="text-sm text-green-100 font-atkinson mb-6">
            Got a question? Or just in the mood for a chat? <br className="hidden sm:block" />
            We're all ears and keyboards! Hit us up—we make <br className="hidden sm:block" />
            insurance talk less 'ugh' and more 'aha!'
          </p>
        </div>
      </div>

    </div>
  </section>
);
